export default [
  // 首页
  {
    path: '/search',
    name:'search',
    meta: {
      title: '搜索',
      showSearch:true,
      loginWithoutVerification: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "feed" */
        '@/views/Search/index'
      ),
  },
];
